import Vue from 'vue';
import AMapLoader from '@amap/amap-jsapi-loader';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
import http from "@/utils/request"
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

window._AMapSecurityConfig = {
  securityJsCode: '9ff9f89645a645ad38a8ed58f2745c8d' // 替换为您的安全密钥
};
// AMapLoader.load({
//   key: '4a55e427d315bb3286f2f0b2bc333be2', // 替换为你的高德地图API Key
//   version: '2.0',
//   plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.Geocoder']
// }).then(() => {
//   Vue.prototype.$AMap = window.AMap;
// });

AMapLoader.load({
  key: '4a55e427d315bb3286f2f0b2bc333be2', // 替换为你的高德地图API Key
  version: '2.0',
  plugins: ['AMap.DistrictSearch', 'AMap.Polygon', "AMap.SatelliteLayer","AMap.Scale", "AMap.ToolBar", "AMap.OverView"]
}).then(() => {
  Vue.prototype.$AMap = window.AMap;
});

Vue.prototype.http = http
//引入echart
//4.x 引用方式
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}
Vue.prototype.msgWaring = function (msg) {
  this.$message({ showClose: true, message: msg, type: "waring" });
}
// 全局注册
Vue.component('icon', Icon);
Vue.use(ElementUI);
Vue.use(dataV);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
